"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LeftNav = void 0;
var react_1 = __importStar(require("react"));
var react_router_dom_1 = require("react-router-dom");
require("./index.less");
var swr_1 = __importDefault(require("swr"));
var chunk_1 = __importDefault(require("lodash/chunk"));
var qihuo_static_1 = require("../../modules/qihuo/qihuo_static");
// import { routerPrefix } from "../../config/web";
var sidemenu_1 = require("../../modules/data/sidemenu");
var inner_pathname = '/gridlist.html';
/**
 * 左侧导航栏
 * @returns
 */
function LeftNav() {
    var _this = this;
    var ref_nav = (0, react_1.useRef)(null);
    var _a = (0, react_1.useState)(null), config = _a[0], SetConfig = _a[1];
    var _b = (0, react_1.useState)(null), pathway = _b[0], SetPathWay = _b[1];
    var location = (0, react_router_dom_1.useLocation)();
    /** 获取配置 */
    var getConfig = function () { return __awaiter(_this, void 0, void 0, function () {
        var config;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, (0, sidemenu_1.getSidemenuData)()];
                case 1:
                    config = _a.sent();
                    SetConfig(config.sidemenu);
                    return [2 /*return*/];
            }
        });
    }); };
    (0, react_1.useEffect)(function () {
        getConfig();
        setTimeout(function () {
            /** hover */
            $("li", '#leftnav').hover(function () {
                var sub_ul = $(this).children('ul');
                var $win = $(window);
                if ((sub_ul === null || sub_ul === void 0 ? void 0 : sub_ul.length) > 0) {
                    var offset = sub_ul.offset(), height = sub_ul.height() || 0;
                    var diff = ($win.height() || 0) + ($win.scrollTop() || 0) - (((offset === null || offset === void 0 ? void 0 : offset.top) || 0) + height + 25);
                    sub_ul.css('top', diff < 0 ? diff : '');
                }
            }, function () {
                $(this).children('ul').css('top', '');
            });
        }, 500);
    }, []);
    (0, react_1.useEffect)(function () {
        var _a;
        // console.info(111)
        //头部高度
        var head_height = ((_a = $('#mainpage').offset()) === null || _a === void 0 ? void 0 : _a.top) || 0;
        //底部高度
        var footer_height = 360;
        function rePosition() {
            //  console.info(222)
            var _a, _b, _c, _d, _e;
            // if (($("#mainc") as any).outerHeight() < ($(ref_nav.current!) as any).outerHeight()) {
            //   $($(ref_nav.current!)?.[0]).css({ position: "", top: "" })
            //   return
            // };
            if (ref_nav.current != null) {
                //视窗高度
                var win_heigth = $(window).height() || 0;
                //整体页面高度
                var body_height = document.body.clientHeight || 0;
                var nav_height = ref_nav.current.clientHeight;
                var mainc_height = ((_a = $("#mainc")) === null || _a === void 0 ? void 0 : _a.outerHeight()) || 0;
                var scrolltop = $(document).scrollTop() || 0;
                //如果主区域高度还没有导航栏高,就不服动了
                if (mainc_height < nav_height) {
                    $((_b = $(ref_nav.current)) === null || _b === void 0 ? void 0 : _b[0]).css({ position: "", top: "", bottom: '' });
                    return false;
                }
                // console.info(nav_height, mainc_height)
                if (scrolltop + 33 > head_height) {
                    //触底
                    if (scrolltop + 33 + nav_height > (body_height - footer_height)) {
                        $((_c = $(ref_nav.current)) === null || _c === void 0 ? void 0 : _c[0]).css({ position: "fixed", bottom: (footer_height - (body_height - scrolltop - win_heigth) - 15) + "px", top: '' });
                    }
                    else {
                        $((_d = $(ref_nav.current)) === null || _d === void 0 ? void 0 : _d[0]).css({ position: "fixed", top: "33px", bottom: '' });
                    }
                }
                else {
                    $((_e = $(ref_nav.current)) === null || _e === void 0 ? void 0 : _e[0]).css({ position: "", top: "", bottom: '' });
                }
                // let scrolltop = $(document).scrollTop() || 0;
                // console.info("scrolltop", scrolltop, 'oftop', oftop)
                // if (scrolltop > oftop) {
                //   //270是底部的高度修正
                //   let diff = win_heigth + 270 + scrolltop - (footer?.offset()?.top || 0) + 100;
                //   if (diff > 0) {
                //     $($(ref_nav.current!)?.[0]).css({ position: "fixed", top: -diff + "px" })
                //   } else {
                //     $($(ref_nav.current!)?.[0]).css({ position: "fixed", top: "33px" })
                //   }
                // } else {
                //   $($(ref_nav.current!)?.[0]).css({ position: "", top: "" })
                // }   
            }
        }
        setTimeout(function () {
            rePosition();
            //浮动
            // let oftop = $($(ref_nav.current!)?.[0])?.offset()?.top || 0;
            // let win_heigth = $(window).height() || 0;
            // let footer = $(".page_footer")
            /** 固顶 */
            $(window).on('scroll', rePosition);
        }, 500);
        try {
            $(window).on('off', rePosition);
        }
        catch (error) {
        }
    }, [location]);
    (0, react_1.useEffect)(function () {
        if (config) {
            SetPathWay(findPathNew(config, location.pathname, location.hash));
        }
    }, [config, location]);
    if (config == null)
        return react_1.default.createElement(react_1.default.Fragment, null);
    return (react_1.default.createElement("div", { className: "leftnav", ref: ref_nav },
        react_1.default.createElement("div", { className: "title" },
            react_1.default.createElement("img", { src: "./static/images/title.png", alt: "\u884C\u60C5\u4E2D\u5FC3" })),
        react_1.default.createElement("ul", { className: "l1" }, config.map(function (v, index) {
            return react_1.default.createElement("li", { key: index, className: (pathway === null || pathway === void 0 ? void 0 : pathway['index' + index]) ? 'active' : '' },
                react_1.default.createElement(NaviLi, { item: v, select: !!(pathway === null || pathway === void 0 ? void 0 : pathway['index' + index]) }),
                v.sub && v.sub.length > 0 &&
                    react_1.default.createElement(react_1.default.Fragment, null,
                        react_1.default.createElement("span", { className: "hastree icon_rarrow" }),
                        react_1.default.createElement(SubTree, { navconfig: v.sub, pathway: pathway === null || pathway === void 0 ? void 0 : pathway['index' + index] })));
        }))));
}
exports.LeftNav = LeftNav;
/**
 * 动态获取期货品种的几个市场
 * 113:上期所 142:上期能源  114:大商所  115:郑商所  225:广期所 220:futures_cffex中金(220)
 */
var futures_market = [
    'futures_113',
    'futures_142',
    'futures_114',
    'futures_115',
    'futures_225',
    'futures_cffex'
];
/**
 * 递归子菜单:二级三级
 * @param props
 * @returns
 */
function SubTree(props) {
    var _a = (0, react_1.useState)(false), loadbk = _a[0], SetLoadBK = _a[1];
    var _b = (0, react_1.useState)(false), loadqh = _b[0], SetLoadQH = _b[1];
    var _c = (0, react_1.useState)(""), curQH = _c[0], SetCurrentQH = _c[1];
    var mouseEnterEvent = function (v) {
        if (v.id == 'concept_board' || v.id == 'region_board' || v.id == 'industry_board_1' || v.id == 'industry_board_2' || v.id == 'industry_board_3') {
            SetLoadBK(true);
        }
        // if (v.id && futures_market.indexOf(v.id) > -1) {
        //   SetLoadQH(true)
        //   SetCurrentQH(v.id)
        // }
    };
    var showItems = props.navconfig.filter(function (v) { return v.show !== false; });
    return (react_1.default.createElement("ul", { className: "lsub" }, showItems.map(function (v, index) {
        var _a, _b, _c;
        return (react_1.default.createElement("li", { key: index, className: ((_a = props.pathway) === null || _a === void 0 ? void 0 : _a['index' + index]) ? 'active' : '', onMouseEnter: function () { mouseEnterEvent(v); } },
            react_1.default.createElement(NaviLi, { item: v }),
            (v.id == 'concept_board' || v.id == 'region_board' || v.id == 'industry_board_1' || v.id == 'industry_board_2' || v.id == 'industry_board_3') ?
                react_1.default.createElement(react_1.default.Fragment, null,
                    react_1.default.createElement("span", { className: "icon_rarrow2 hastree2" }),
                    loadbk &&
                        react_1.default.createElement(BoardTree, { type: v.id }))
                :
                    // (v.id && futures_market.indexOf(v.id) > -1) ?
                    //   <>
                    //     <span className="icon_rarrow2 hastree2"></span>
                    //     {
                    //       loadqh && v.id == curQH && <FuturesTree type={v.id}></FuturesTree>
                    //     }
                    //   </>
                    //   :
                    v.sub && ((_b = v.sub.filter(function (v) { return v.show != false; })) === null || _b === void 0 ? void 0 : _b.length) > 0 &&
                        react_1.default.createElement(react_1.default.Fragment, null,
                            react_1.default.createElement("span", { className: "icon_rarrow2 hastree2" }),
                            react_1.default.createElement(SubTree, { navconfig: v.sub, pathway: (_c = props.pathway) === null || _c === void 0 ? void 0 : _c['index' + index] }))));
    })));
}
/** 菜单内容 */
function NaviLi(props) {
    // console.info(window.mainpath)
    return (react_1.default.createElement(react_1.default.Fragment, null,
        props.item.path != undefined &&
            react_1.default.createElement(react_router_dom_1.Link, { to: '/' + window.mainpath + (props.item.path.indexOf('#') == 0 ? inner_pathname : '') + props.item.path, onClick: ClickHide },
                props.item.icon &&
                    react_1.default.createElement("span", { className: 'leftnav_icon ' + props.item.icon + (props.select ? " on" : "") }),
                props.item.title,
                props.item.hot && react_1.default.createElement("span", { className: "icon_hot_nav" })),
        props.item.link &&
            react_1.default.createElement("a", { href: props.item.link.indexOf('/center/') == 0 ? props.item.link.replace('/center/', "/".concat(window.mainpath, "/")) : props.item.link },
                props.item.icon &&
                    react_1.default.createElement("span", { className: 'leftnav_icon ' + props.item.icon }),
                props.item.title,
                props.item.hot && react_1.default.createElement("span", { className: "icon_hot_nav" }))));
}
/** 查找菜单路径 */
function findPath(config, pathname, hash) {
    var path = pathname + hash;
    var result = null;
    config.forEach(function (v, index) {
        var _a, _b, _c;
        if (v.path == path) {
            result = (_a = {},
                _a['index' + index] = 1,
                _a);
        }
        if (v.sub) {
            var findsub = findPath(v.sub, pathname, hash);
            if (findsub) {
                result = (_b = {},
                    _b['index' + index] = findsub,
                    _b);
            }
        }
        // 板块三级特殊处理
        if (v.path == '/hsbk.html') {
            if (pathname == '/gridlist.html' && hash.indexOf("boards2-") > -1) {
                return result = (_c = {},
                    _c['index' + index] = 1,
                    _c);
            }
        }
    });
    return result;
}
/**
 * 查找菜单路径(index计算跳过有隐藏的元素)
 * @param config
 * @param pathname
 * @param hash
 * @returns
 */
function findPathNew(config, pathname, hash) {
    pathname = pathname.replace('/' + window.mainpath, "");
    var path = pathname + hash;
    var result = null;
    // 当前元素前面设置为隐藏的兄弟元素个数
    var prehidenum = 0;
    config.forEach(function (v, index) {
        var _a, _b, _c;
        if (v.show === false) {
            prehidenum++;
        }
        var vpath = v.path;
        if (vpath && vpath.indexOf('#') == 0)
            vpath = '/gridlist.html' + vpath;
        if (vpath == path) {
            var num = v.show !== false ? index - prehidenum : null;
            result = (_a = {},
                _a['index' + num] = 1,
                _a);
        }
        if (v.sub) {
            var findsub = findPathNew(v.sub, pathname, hash);
            if (findsub) {
                result = (_b = {},
                    _b['index' + index] = findsub,
                    _b);
            }
        }
        // 板块三级特殊处理
        if (vpath == '/hsbk.html') {
            if (pathname == '/gridlist.html' && hash.indexOf("boards2-") > -1) {
                return result = (_c = {},
                    _c['index' + index] = 1,
                    _c);
            }
        }
    });
    return result;
}
/**
 * 板块菜单
 */
function BoardTree(props) {
    // console.info('BoardTree')
    var showdata = [];
    var _a = (0, swr_1.default)("all_bk_info", function () { return (0, sidemenu_1.getSidemenuData)(); }, {
        revalidateOnFocus: false
    }), data = _a.data, error = _a.error;
    // console.info(data)
    if (data) { //处理数据
        // console.info(data)
        var filtertype_1 = '';
        var filtertype2_1 = '';
        switch (props.type) {
            case 'concept_board':
                filtertype_1 = '3';
                break;
            case 'region_board':
                filtertype_1 = '1';
                break;
            case 'industry_board_1':
                filtertype_1 = '2';
                filtertype2_1 = '1';
                break;
            case 'industry_board_2':
                filtertype_1 = '2';
                filtertype2_1 = '2';
                break;
            case 'industry_board_3':
                filtertype_1 = '2';
                filtertype2_1 = '3';
                break;
        }
        var now_letter_1 = '';
        if (filtertype2_1 == '') {
            showdata = data.bklist.filter(function (v) { return v.type == filtertype_1; });
        }
        else {
            showdata = data.bklist.filter(function (v) { return v.type == filtertype_1 && v.flag == filtertype2_1; });
        }
        showdata = showdata.sort(function (v1, v2) {
            if (v1.pinyin.charCodeAt(0) - v2.pinyin.charCodeAt(0) == 0) {
                if (v1.name.charCodeAt(0) - v2.name.charCodeAt(0) == 0) {
                    return v1.name.charCodeAt(1) - v2.name.charCodeAt(1);
                }
                return v1.name.charCodeAt(0) - v2.name.charCodeAt(0);
            }
            return v1.pinyin.charCodeAt(0) - v2.pinyin.charCodeAt(0);
        }).map(function (v) {
            var letter = v.pinyin.substring(0, 1);
            if (!/[a-zA-Z]/.test(letter)) {
                letter = "#";
            }
            var showletter = '';
            if (now_letter_1 != letter) {
                now_letter_1 = letter;
                showletter = letter;
            }
            return __assign({ letter: showletter }, v);
        });
    }
    if (showdata.length > 0) {
        return (react_1.default.createElement("div", { className: "boardtree" },
            react_1.default.createElement("div", { className: "boardtreeb" }, (0, chunk_1.default)(showdata, 25).map(function (v, index) {
                return react_1.default.createElement("ul", { className: "boardtree_wrapper", key: index }, v.map(function (v2, index2) {
                    return react_1.default.createElement(react_router_dom_1.Link, { key: index2, to: "".concat('/' + window.mainpath, "/gridlist.html#boards2-").concat(v2.market, ".").concat(v2.code), onClick: ClickHide },
                        react_1.default.createElement("li", null,
                            react_1.default.createElement("span", { className: "letter" }, v2.letter),
                            react_1.default.createElement("span", { className: "sub-link", title: v2.name }, v2.name)));
                }));
            }))));
    }
    return react_1.default.createElement(react_1.default.Fragment, null);
}
/**
 * 期货市场
 * @param props
 * @returns
 */
function FuturesTree(props) {
    var market = props.type.replace("futures_", "");
    market = market == "cffex" ? "220" : market; // 中金
    var _a = (0, swr_1.default)("/redis_".concat(market), function () { return (0, qihuo_static_1.getFutureSelectLevel1)(market); }, {
        refreshInterval: 60 * 30 * 1000,
        dedupingInterval: 59 * 30 * 1000
    }), data = _a.data, error = _a.error;
    var _b = (0, react_1.useState)(""), curitem = _b[0], setCurent = _b[1];
    (0, react_1.useEffect)(function () {
        setCurent(location.hash);
    }, [location.hash]);
    if (!data)
        return react_1.default.createElement(react_1.default.Fragment, null);
    var showdata = [];
    showdata = data.map(function (v) {
        return {
            path: "/gridlist.html#futures_".concat(market, "_").concat(v.vtype),
            title: v.vname,
            hashkey: "#futures_".concat(market, "_").concat(v.vtype)
        };
    });
    return (react_1.default.createElement("ul", { className: "lsub" }, showdata.map(function (v, index) {
        return (react_1.default.createElement("li", { key: index, className: curitem == v.hashkey ? 'active' : '', onClick: ClickHide }, v.path && react_1.default.createElement(react_router_dom_1.Link, { to: '/' + window.mainpath + (v.path.indexOf('#') == 0 ? inner_pathname : '') + v.path },
            " ",
            v.title)));
    })));
}
/**
 * 点击之后二级菜单消失
 */
function ClickHide() {
    $('.lsub').css({ display: 'none' });
    setTimeout(function () {
        $('.lsub').css({ display: '' });
    }, 100);
}
